// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__Up1AI","errors":"Errors_errors__21cVI"};